<template>
  <GmapMap :center="center"
           :zoom="zoom"
           map-type-id="terrain"
           style="width: 200px; height: 189px"
           :options="{
             zoomControl: true,
             mapTypeControl: false,
             scaleControl: false,
             streetViewControl: false,
             rotateControl: false,
             fullscreenControl: true,
             disableDefaultUi: false
           }">
    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      //your custom html components
      <button type="button"
              style="background-color: pink;">
        Hello!
      </button>
      <ul>
        <li>
          List Item
        </li>
        <li>
          Another One
        </li>
      </ul>
    </gmap-info-window>

  <GmapMarker :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                :icon="m.icon"
                @click="toggleInfoWindow(m,i)" />
  </GmapMap>
</template>

<script>

  var center = { lat: 10, lng: 10 };

  var markers = [
    
  ];

  var zoom = 7;

  const iconBase =
    "https://developers.google.com/maps/documentation/javascript/examples/full/images/";

  const icons = {
    parking: {
      icon: iconBase + "parking_lot_maps.png",
    },
    library: {
      icon: iconBase + "library_maps.png",
    },
    info: {
      icon: iconBase + "info-i_maps.png",
    },
  };


export default {
  name: "gmaptest",
  components: {
    
    },
    props: {
      zoomlevel: {
        required: false,
        type: Number,
        default: 7
      },
    },
    data() {
      return {
        center,
        markers,
        lines: [],
        zoom: this.zoomlevel,
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        }
      }
    },
  methods: {
    changeMarkers() {
      //alert('changing markers')
      this.markers = [{
        id: "a",
        position: { lat: 3, lng: 101 },
        icon: { url: icons["info"].icon }

      },
      {
        id: "b",
        position: { lat: 5, lng: 99 },
        icon: { url: icons["parking"].icon },
      },
        {
          id: "c",
          position: { lat: 6, lng: 97 },
          icon: { url: icons["library"].icon }
      }]
    },
    setCenter(lat, long) {
      this.center = { lat: lat, lng: long }
    },
    centerMyPosition() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setCenter(position.coords.latitude, position.coords.longitude)
      });
    },
    centerOnAddress(address) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, (results, status) => {
        if (status === 'OK') {
          this.setCenter(results[0].geometry.location.lat(), results[0].geometry.location.lng())
        }
      });
    },
    setZoom(zoom) {
      this.zoom = zoom;
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    }
  },
  computed: {
    
  },
    async mounted() {
      //var thisContext = this;
      await this.$gmapApiPromiseLazy(); // Ensures that google map is loaded
      //this.centerOnAddress("thailand");
      //setTimeout(this.changeMarkers, 5000);
      //setTimeout(function () { thisContext.setZoom(2)}, 15000);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/maps/gmaptest.vue